import { FC } from "react";
import { IUserBalances } from "../../model/user-info.interface";
import { Ticket, TicketsPanelContext, TicketType } from "./Ticket";
import styles from "./Tickets.module.scss";

interface ITicketsProps extends Partial<IUserBalances> {
    context?: TicketsPanelContext;
    prefix?: string;
    tooltips?: string[];
    precission?: number;
}

export const Tickets: FC<ITicketsProps> = ({ prefix, context = '', tooltips, precission, ...tickets }) => {    
    return (
        <div className={`${styles.panel} ${styles[context]}`}>
            {(Object.entries(tickets) as Array<[keyof IUserBalances, number]>).map(([key, value], index) => (
                <Ticket 
                    key={`ticket-${key}`}
                    value={value}
                    type={key as TicketType}
                    prefix={ prefix }
                    context={ context }
                    tooltip={ tooltips?.[index] }
                    precission={ precission }
                />
            ))}
        </div>
    );
}